if (!customElements.get('premium-trust-strip')) {
  customElements.define('premium-trust-strip', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.track = this.querySelector('.pts__list');
      this.controls = this.querySelector('.pts__controls');
      this.previous = this.querySelector('[data-trust-previous]');
      this.next = this.querySelector('[data-trust-next]');
      this.position = this.querySelector('.pts__position');
      if (!this.track || !this.controls || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !this.max) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.scrollTo(0);
        else if (event.key === 'End') this.scrollTo(this.rtl ? -this.max : this.max);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('.pts__item');
        if (!item || !this.contains(item) || !this.max) return;
        this.scrollTo(this.track.scrollLeft + item.getBoundingClientRect().left - this.track.getBoundingClientRect().left);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
    update() {
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      this.max = getComputedStyle(this.track).overflowX === 'auto' ? Math.max(0, this.track.scrollWidth - this.track.clientWidth) : 0;
      const offset = Math.abs(this.track.scrollLeft);
      this.controls.hidden = this.max <= 1;
      this.track.tabIndex = this.max > 1 ? 0 : -1;
      this.previous.disabled = offset <= 1;
      this.next.disabled = offset >= this.max - 1;
      const items = Array.from(this.track.children);
      const visible = items.filter((item) => {
        const bounds = item.getBoundingClientRect();
        const track = this.track.getBoundingClientRect();
        return bounds.right > track.left + 1 && bounds.left < track.right - 1;
      });
      const first = items.indexOf(visible[0]) + 1;
      const last = items.indexOf(visible[visible.length - 1]) + 1;
      if (this.position) this.position.textContent = `${first === last ? first : `${first}\u2013${last}`} / ${items.length}`;
    }
    move(direction) {
      const item = this.track.firstElementChild;
      if (!item) return;
      this.scrollTo(this.track.scrollLeft + direction * (this.rtl ? -1 : 1) * item.getBoundingClientRect().width);
    }
    scrollTo(left) {
      this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  });
}
